import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {StudentActivityListComponent} from './components/student-activity-list/student-activity-list.component';

const routes: Routes = [
  {path: '**', component: StudentActivityListComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ActivityRoutingModule { }
